import modelBase from "../model-base.model";
import _ from "lodash";
import moment from "moment";
import { formats as FORMATS } from "../../config/constants";
import loginModel from "../login.model";

var assignScheduleModel = {

  formDataList: [],
  scheduleDateList: [],

  // Default values
  formData: {
    userID: '',
    siteId: '',
    scheduleDate: '',
    workType: '001',
    leaveDayOffType: '',
    workTemplateID: 0,
    startTime: '',
    endTime: '',
    timeRequiredYN: '',
    breakHourRequiredYN: '',
    remarks: '',
    action: '',

    _breakHour: '00',
    _breakMinute: '00',
    get hourOfBreakHour() {
      return this._breakHour;
    },
    set hourOfBreakHour(hr) {
      hr = parseInt(hr);
      if (isNaN(hr)) {
        this._breakHour = '00';
      } else {
        hr = hr > 23 ? '0' : hr < 0 ? '23' : hr;
        this._breakHour = _.padStart(hr, 2, '0');
      }
    },
    get minuteOfBreakHour() {
      return this._breakMinute;
    },
    set minuteOfBreakHour(mn) {
      mn = parseInt(mn);
      if (isNaN(mn)) {
        this._breakMinute = '00';
      } else {
        mn = mn > 59 ? '0' : mn < 0 ? '59' : mn;
        this._breakMinute = _.padStart(mn, 2, '0');
      }
    },
    get breakHour() {
      return this.hourOfBreakHour.toString() + ':' + this.minuteOfBreakHour.toString();
    },
    set breakHour(time) {
      if (time && time.toString().includes(":")) { // check if param is HH:mm format
        this.hourOfBreakHour = time.split(":")[0]; // get HH
        this.minuteOfBreakHour = time.split(":")[1]; // get mm
      }
    }
  },

  displayScheduleDates: function () {
    let dateString = '';
    if (assignScheduleModel.scheduleDateList.length === 1) {
      dateString = assignScheduleModel.scheduleDateList[0];
    } else if (assignScheduleModel.scheduleDateList.length > 1) {
      assignScheduleModel.scheduleDateList.sort();
      dateString = assignScheduleModel.scheduleDateList[0] + ' ~ ' + assignScheduleModel.scheduleDateList[assignScheduleModel.scheduleDateList.length - 1];
    }

    return dateString;
  },

  addFormDataToList: function () {
    assignScheduleModel.formDataList.push(assignScheduleModel.formData);
  },

  resetFormDataList: function () {
    assignScheduleModel.formDataList = [];
  },

  resetFormData: function () {
    assignScheduleModel.formData.userID = '';
    assignScheduleModel.formData.siteId = '';
    assignScheduleModel.formData.scheduleDate = '';
    assignScheduleModel.formData.workType = '001';
    assignScheduleModel.formData.leaveDayOffType = '';
    assignScheduleModel.formData.workTemplateID = 0;
    assignScheduleModel.formData.startTime = '';
    assignScheduleModel.formData.endTime = '';
    assignScheduleModel.formData.timeRequiredYN = '';
    assignScheduleModel.formData.breakHourRequiredYN = '';
    assignScheduleModel.formData.remarks = '';
    assignScheduleModel.formData.action = '';
    assignScheduleModel.formData.breakHour = '00:00';
  },

  onWorkTypeChange: function () {
    assignScheduleModel.formData.siteId = '';
    assignScheduleModel.formData.leaveDayOffType = '';
    assignScheduleModel.formData.workTemplateID = 0;
    assignScheduleModel.formData.startTime = '';
    assignScheduleModel.formData.endTime = '';
    assignScheduleModel.formData.timeRequiredYN = '';
    assignScheduleModel.formData.breakHourRequiredYN = '';
    assignScheduleModel.formData.remarks = '';
    assignScheduleModel.formData.action = '';
    assignScheduleModel.formData.breakHour = '00:00';
  },

  getWorkTypeList: function (successCallBack, failureCallBack) {
    const countryCode = loginModel.credentials.country;
    modelBase.get(successCallBack, failureCallBack, `/api/codemaster/worktype?countryCode=${countryCode}`);
  },

  getLeaveTypeList: function (successCallBack, failureCallBack) {
    const countryCode = loginModel.credentials.country;
    modelBase.get(successCallBack, failureCallBack, `/api/codemaster/leavetype?countryCode=${countryCode}`);
  },

  getDayOffTypeList: function (successCallBack, failureCallBack) {
    const countryCode = loginModel.credentials.country;
    modelBase.get(successCallBack, failureCallBack, `/api/codemaster/dayofftype?countryCode=${countryCode}`);
  },

  getManagedSiteList: function (successCallBack, failureCallBack, filter) {
    modelBase.get(successCallBack, failureCallBack, `/api/site/managed/${filter.countryCode}/${filter.userId}`);
  },

  getWorkTemplateListByWorkType: function (successCallBack, failureCallBack) {
    let filter = {};
    if (!_.isEmpty(assignScheduleModel.formData.workType)) {
      filter.workType = assignScheduleModel.formData.workType;
    }
    const qs = modelBase.toQueryString(filter);
    modelBase.get(successCallBack, failureCallBack, '/api/schedule/workTemplate/active?' + qs);
  },

  assignSchedule: function (successCallBack, failureCallBack) {
    assignScheduleModel.formData.action = 'A';
    let _body = {};
    _body.schedule = assignScheduleModel.formDataList;

    assignScheduleModel.scheduleDateList.map(date => {
      let fd = _.omit(assignScheduleModel.formData, ['_breakHour', '_breakMinute', 'hourOfBreakHour', 'minuteOfBreakHour']);
      fd.scheduleDate = moment(date, FORMATS.dateFormat).format(FORMATS.apiDateFormat); // YYYY.MM.DD --> YYYYMMDD
      assignScheduleModel.formDataList.push(fd);
    });

    modelBase.post(successCallBack, failureCallBack, `/api/schedule/create`, { body: _body });
  },

}

export default assignScheduleModel;
